module.exports = __webpack_public_path__ + "assets/img/37_1454_big.d2191424.jpg";